import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./../Button";
import { Strings } from "../../Stores/StringsStore";

@observer
export class RotateCounterClockwiseButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.reader.rotateCounterClockwiseButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M6.83,21.65A10.26,10.26,0,1,0,8.55,8.38l3.35,2.78L2.22,13.41,2.69,3.52l3.13,2.6A13.75,13.75,0,1,1,4.09,23.84Z" />
				</svg>
			</i>
		</Button>;
	}
}
